const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const days = () => {
  const arr = [];
  for (let i = 1; i < 31; i++) {
    arr.push(i);
  }
  return arr;
};
const years = () => {
  const arr = [];
  const year = new Date().getFullYear();
  for (let i = year; i > year - 30; i--) {
    arr.push(i);
  }
  return arr;
};

const convertToDate = (timestamp) => {
  return `${
    new Date(
      timestamp < 157766400000 ? timestamp * 1000 : timestamp
    ).getDate() < 10
      ? `0${new Date(
          timestamp < 157766400000 ? timestamp * 1000 : timestamp
        ).getDate()}`
      : new Date(
          timestamp < 157766400000 ? timestamp * 1000 : timestamp
        ).getDate()
  }/${
    new Date(
      timestamp < 157766400000 ? timestamp * 1000 : timestamp
    ).getMonth() < 9
      ? `0${
          new Date(
            timestamp < 157766400000 ? timestamp * 1000 : timestamp
          ).getMonth() + 1
        }`
      : `${
          new Date(
            timestamp < 157766400000 ? timestamp * 1000 : timestamp
          ).getMonth() + 1
        }`
  }/${new Date(
    timestamp < 157766400000 ? timestamp * 1000 : timestamp
  ).getUTCFullYear()}`;
};

const sorttimestamp = (a, b) => {
  if (a < 157766400000 && b < 157766400000) {
    return a > b ? 1 : -1;
  } else if (a < 157766400000 && b > 157766400000) {
    return a * 1000 > b ? 1 : -1;
  } else if (a > 157766400000 && b < 157766400000) {
    return a / 1000 > b ? 1 : -1;
  } else {
    return a > b ? 1 : -1;
  }
};

const userRoles = [
  "Artist",
  "A&R",
  "Agent",
  "Backing Vocalist",
  "Band",
  "Beat Maker",
  "Blogger",
  "Booking Agent",
  "DJ",
  "Engineer",
  "Executive",
  "Graphic Designer",
  "Influencer",
  "Label",
  "Lawyer",
  "Manager",
  "Marketing",
  "MUA",
  "Music Editor",
  "Music Producer",
  "Photographer",
  "Podcaster",
  "Promoter",
  "Publicist",
  "Publisher",
  "Radio Plugger",
  "Radio Producer",
  "Rapper",
  "Session Musician",
  "Singer",
  "Songwriter",
  "Sound Technician",
  "Stylist",
  "Tour Manager",
  "Commisioner",
  "Video Director",
  "Video Producer",
];

const genres = [
  "Afro",
  "Alternative Rock",
  "Blues",
  "Carribean",
  "Classical",
  "Country",
  "Dance",
  "Dancehall",
  "Desi",
  "EDM",
  "Folk",
  "Hip Hop",
  "House",
  "Indie",
  "Jazz",
  "K-Pop",
  "Latin",
  "Metal",
  "Podcast",
  "Pop",
  "Punk",
  "R&B",
  "Rap",
  "Reggae",
  "Rock",
  "Soul",
  "Techno",
  "UK Rap",
  "US Rap",
];

const allRoles = [
  "Artist",
  "Backing Vocalist",
  "Band",
  "Beat Maker",
  "DJ",
  "Engineer",
  "Music Producer",
  "Mixer",
  "Rapper",
  "Session Musician",
  "Singer",
  "Songwriter",
  "Sound Technician",
  "Art Director",
  "Assistant Editor",
  "Assistant Director",
  "Casting",
  "Choreographer",
  "Director",  
  "DP",
  "Editor",
  "Executive Producer",
  "Hair Stylist",
  "MUA",
  "Runner",
  "Production Company",
  "Talent",
  "VFX",
  "Video Director",
  "Video Producer", 
  "A&R",
  "Agent",
  "Artist Manager",
  "Booking Agent",
  "Executive",
  "Label",
  "Lawyer",
  "Manager",
  "Promoter",
  "Publicist",
  "Publisher",
  "Radio Plugger",
  "Radio Producer",
  "Tour Manager",
  "Video Commisioner",
  "Blogger",
  "Graphic Designer",
  "Influencer",
  "Marketers",
  "Music Editor",
  "Podcaster",
  "Photographer",
  "Stylist",
];

const locations = [
    "Bangladesh",
    "Belgium",
    "Burkina Faso",
    "Bulgaria",
    "Bosnia and Herzegovina",
    "Barbados",
    "Wallis and Futuna",
    "Saint Barthelemy",
    "Bermuda",
    "Brunei",
    "Bolivia",
    "Bahrain",
    "Burundi",
    "Benin",
    "Bhutan",
    "Jamaica",
    "Bouvet Island",
    "Botswana",
    "Samoa",
    "Bonaire, Saint Eustatius and Saba ",
    "Brazil",
    "Bahamas",
    "Jersey",
    "Belarus",
    "Belize",
    "Russia",
    "Rwanda",
    "Serbia",
    "East Timor",
    "Reunion",
    "Turkmenistan",
    "Tajikistan",
    "Romania",
    "Tokelau",
    "Guinea-Bissau",
    "Guam",
    "Guatemala",
    "South Georgia and the South Sandwich Islands",
    "Greece",
    "Equatorial Guinea",
    "Guadeloupe",
    "Japan",
    "Guyana",
    "Guernsey",
    "French Guiana",
    "Georgia",
    "Grenada",
    "United Kingdom",
    "Gabon",
    "El Salvador",
    "Guinea",
    "Gambia",
    "Greenland",
    "Gibraltar",
    "Ghana",
    "Oman",
    "Tunisia",
    "Jordan",
    "Croatia",
    "Haiti",
    "Hungary",
    "Hong Kong",
    "Honduras",
    "Heard Island and McDonald Islands",
    "Venezuela",
    "Puerto Rico",
    "Palestinian Territory",
    "Palau",
    "Portugal",
    "Svalbard and Jan Mayen",
    "Paraguay",
    "Iraq",
    "Panama",
    "French Polynesia",
    "Papua New Guinea",
    "Peru",
    "Pakistan",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Saint Pierre and Miquelon",
    "Zambia",
    "Western Sahara",
    "Estonia",
    "Egypt",
    "South Africa",
    "Ecuador",
    "Italy",
    "Vietnam",
    "Solomon Islands",
    "Ethiopia",
    "Somalia",
    "Zimbabwe",
    "Saudi Arabia",
    "Spain",
    "Eritrea",
    "Montenegro",
    "Moldova",
    "Madagascar",
    "Saint Martin",
    "Morocco",
    "Monaco",
    "Uzbekistan",
    "Myanmar",
    "Mali",
    "Macao",
    "Mongolia",
    "Marshall Islands",
    "Macedonia",
    "Mauritius",
    "Malta",
    "Malawi",
    "Maldives",
    "Martinique",
    "Northern Mariana Islands",
    "Montserrat",
    "Mauritania",
    "Isle of Man",
    "Uganda",
    "Tanzania",
    "Malaysia",
    "Mexico",
    "Israel",
    "France",
    "British Indian Ocean Territory",
    "Saint Helena",
    "Finland",
    "Fiji",
    "Falkland Islands",
    "Micronesia",
    "Faroe Islands",
    "Nicaragua",
    "Netherlands",
    "Norway",
    "Namibia",
    "Vanuatu",
    "New Caledonia",
    "Niger",
    "Norfolk Island",
    "Nigeria",
    "New Zealand",
    "Nepal",
    "Nauru",
    "Niue",
    "Cook Islands",
    "Kosovo",
    "Ivory Coast",
    "Switzerland",
    "Colombia",
    "China",
    "Cameroon",
    "Chile",
    "Cocos Islands",
    "Canada",
    "Republic of the Congo",
    "Central African Republic",
    "Democratic Republic of the Congo",
    "Czech Republic",
    "Cyprus",
    "Christmas Island",
    "Costa Rica",
    "Curacao",
    "Cape Verde",
    "Cuba",
    "Swaziland",
    "Syria",
    "Sint Maarten",
    "Kyrgyzstan",
    "Kenya",
    "South Sudan",
    "Suriname",
    "Kiribati",
    "Cambodia",
    "Saint Kitts and Nevis",
    "Comoros",
    "Sao Tome and Principe",
    "Slovakia",
    "South Korea",
    "Slovenia",
    "North Korea",
    "Kuwait",
    "Senegal",
    "San Marino",
    "Sierra Leone",
    "Seychelles",
    "Kazakhstan",
    "Cayman Islands",
    "Singapore",
    "Sweden",
    "Sudan",
    "Dominican Republic",
    "Dominica",
    "Djibouti",
    "Denmark",
    "British Virgin Islands",
    "Germany",
    "Yemen",
    "Algeria",
    "United States",
    "Uruguay",
    "Mayotte",
    "United States Minor Outlying Islands",
    "Lebanon",
    "Saint Lucia",
    "Laos",
    "Tuvalu",
    "Taiwan",
    "Trinidad and Tobago",
    "Turkey",
    "Sri Lanka",
    "Liechtenstein",
    "Latvia",
    "Tonga",
    "Lithuania",
    "Luxembourg",
    "Liberia",
    "Lesotho",
    "Thailand",
    "French Southern Territories",
    "Togo",
    "Chad",
    "Turks and Caicos Islands",
    "Libya",
    "Vatican",
    "Saint Vincent and the Grenadines",
    "United Arab Emirates",
    "Andorra",
    "Antigua and Barbuda",
    "Afghanistan",
    "Anguilla",
    "U.S. Virgin Islands",
    "Iceland",
    "Iran",
    "Armenia",
    "Albania",
    "Angola",
    "Antarctica",
    "American Samoa",
    "Argentina",
    "Australia",
    "Austria",
    "Aruba",
    "India",
    "Aland Islands",
    "Azerbaijan",
    "Ireland",
    "Indonesia",
    "Ukraine",
    "Qatar",
    "Mozambique"
];

export { years, days, months, genres, userRoles, locations, convertToDate, sorttimestamp, allRoles };
